<div id="overlay">
    <div class="spinner spinner-icon"></div>
</div>